import { Component, OnInit , Input, Output, EventEmitter, AfterViewInit, OnChanges} from '@angular/core';
import { BoxOpenModeService } from '../../../services/boxOpenMode/boxOpenMode.service';


@Component({
  selector: 'mobileCheckBox',
  template: require('./mobilecheckbox.component.html'),
  styles: [require('./mobilecheckbox.component.scss')]
})
export class mobileCheckBox implements OnInit, AfterViewInit, OnChanges {


private _checked:boolean = false;
 @Input() public set checked(value: any) {

  this._checked = value;
 
}

public get checked()
{
  return this._checked;
}

  private _label: string = "";
  public get label (): string {
    return this._label;
  }
  public set label ( value: string ) {
    this._label = value;
  }

@Input() public set inputValue(value: any) {

  //  this._categoryId = value;
  //  this.doSomething(this._categoryId);
      this.label = value;
}





  @Output('update')
  change: EventEmitter<boolean> = new EventEmitter<boolean>();

  
  increment() {
    this.checked = !this.checked;
    this.change.emit(this.checked);
  }

  constructor() {}

  ngAfterViewInit()
  {
  //  this.currentValue=this.inputValue;
  }

  ngOnInit() { 
  //  this.currentValue=this.inputValue;
  }

  public emitValue()
  {
    this.increment();
  }

  get screnWidth()
  {
    return  window.innerWidth;
  }


  ngOnChanges() {}



}
